package ro.horatiu_udrea.resursedeblocat

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class AdminViewModel {
    var users by mutableStateOf<List<User>>(emptyList())
        private set

    var isLoadingUsers by mutableStateOf(false)
        private set

    var selectedUser by mutableStateOf<User?>(null)
        private set

    var userResources by mutableStateOf<List<ResourceDetails>>(emptyList())
        private set

    var userTrackings by mutableStateOf<List<MonthlyTracking>>(emptyList())
        private set

    var isLoadingUserData by mutableStateOf(false)
        private set

    var error by mutableStateOf<String?>(null)
        private set

    var userLastTrackings by mutableStateOf<Map<String, MonthlyTracking?>>(emptyMap())
        private set

    private val trackingListeners = mutableMapOf<String, () -> Unit>()

    fun loadUsers() {
        isLoadingUsers = true
        error = null
        getAllUsers(
            onSuccess = { fetchedUsers ->
                users = fetchedUsers
                isLoadingUsers = false
                // Clear existing listeners
                trackingListeners.values.forEach { it() }
                trackingListeners.clear()
                
                fetchedUsers.forEach { user ->
                    listenToUserLastTracking(user.id)
                }
            },
            onFailure = { err ->
                error = err
                isLoadingUsers = false
            }
        )
    }

    private fun listenToUserLastTracking(userId: String) {
        val unsubscribe = listenToUserTrackings(
            targetUserId = userId,
            onUpdate = { trackings ->
                val current = getCurrentMonthYear()
                var targetMonth = current.month - 1
                var targetYear = current.year
                if (targetMonth == 0) {
                    targetMonth = 12
                    targetYear -= 1
                }
                
                val lastMonthTracking = trackings.firstOrNull { it.month == targetMonth && it.year == targetYear }
                userLastTrackings = userLastTrackings + (userId to lastMonthTracking)
            },
            onFailure = { _ ->
                userLastTrackings = userLastTrackings + (userId to null)
            }
        )
        trackingListeners[userId] = unsubscribe
    }

    fun onDispose() {
        trackingListeners.values.forEach { it() }
        trackingListeners.clear()
    }

    fun selectUser(user: User?) {
        selectedUser = user
        if (user != null) {
            loadUserData(user.id)
        } else {
            userResources = emptyList()
            userTrackings = emptyList()
        }
    }

    private fun loadUserData(userId: String) {
        isLoadingUserData = true
        error = null
        
        var resourcesLoaded = false
        var trackingsLoaded = false

        getUserResources(
            targetUserId = userId,
            onSuccess = { resources ->
                userResources = resources.sortedByDescending { it.addedAt }
                resourcesLoaded = true
                if (trackingsLoaded) isLoadingUserData = false
            },
            onFailure = { err ->
                error = err
                resourcesLoaded = true
                if (trackingsLoaded) isLoadingUserData = false
            }
        )

        getUserTrackings(
            targetUserId = userId,
            onSuccess = { trackings ->
                userTrackings = trackings.sortedByDescending { it.year * 12 + it.month }
                trackingsLoaded = true
                if (resourcesLoaded) isLoadingUserData = false
            },
            onFailure = { err ->
                error = err
                trackingsLoaded = true
                if (resourcesLoaded) isLoadingUserData = false
            }
        )
    }
}
